export default __webpack_public_path__ + "static/media/banner-standards.d7a0f949.png";